<template>
  <div class="home">
    <!-- 顶栏：品牌 / 批量工具 / 语言 / 钱包。样式在 theme.css 的「4. 页面外壳」 -->
    <header class="topbar">
      <div class="topbar-inner">
        <div class="topbar-brand">
          <img src="../img/tokenlogo.png" alt="GTokenTool" />
          <span class="brand-word">GTokenTool</span>
        </div>
        <div class="topbar-right">
          <a
            class="topbar-link"
            href="https://gtokentool.com/sendertoken"
            target="_blank"
            rel="noopener"
            >{{ $t("home.MultiSender") }}</a
          >
          <el-dropdown trigger="click" @command="translate">
            <button
              class="ctrl ctrl-lang"
              type="button"
              aria-haspopup="true"
              :aria-label="$t('home.langLabel')"
            >
              <img src="../img/11.png" alt="" />
              <span>{{ langLabel }}</span>
              <i class="el-icon-arrow-down"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">简体中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <button
            class="ctrl wallet-btn"
            :class="{ 'is-connected': connected }"
            type="button"
            :aria-label="connected ? ownadress : $t('home.wallet')"
            @click="lian"
          >
            <span v-if="connected" class="dot"></span>
            {{ connected ? ownadress : $t("home.wallet") }}
          </button>
        </div>
      </div>
      <div class="scale-rule"></div>
    </header>

    <main class="page">
      <div class="page-head">
        <span class="spec">Any EVM Chain · Token Creator</span>
        <h1>{{ $t("home.anyChainTitle") }}</h1>
        <p>{{ $t("home.anyChainLead") }}</p>
      </div>

      <div class="grid-main">
        <!-- 01 创建代币 -->
        <section class="card">
          <header class="card-head">
            <span class="spec-code spec">01</span>
            <h2>{{ $t("home.chuangjian") }}</h2>
            <span class="spec is-faint card-head-meta">{{
              $t(`home.${currentMode.label}`)
            }}</span>
          </header>
          <div class="card-body">
            <!-- 模式：两张卡，选完一眼能看出「要填什么」 -->
            <span class="spec mode-label">{{ $t("home.moshi") }}</span>
            <div class="mode-picker">
              <button
                v-for="item in options"
                :key="item.value"
                type="button"
                class="mode-card"
                :class="{ on: value === item.value }"
                @click="value = item.value"
              >
                <b>{{ $t(`home.${item.label}`) }}</b>
                <span>{{ $t(`home.${item.label}Tip`) }}</span>
              </button>
            </div>
            <!-- 费用行：左边是这次要付的金额 + 原生币单位，右边是当前链的名字与 chainId
                 —— 用户不用点开钱包就知道自己在哪条链上、要付什么币 -->
            <p class="fee-line">
              <span class="spec is-faint">Fee</span>
              <b class="fee-value">{{ feeLabel }}</b>
              <span class="fee-chain">
                <span class="spec is-faint">{{ $t("home.currentChain") }}</span>
                <span class="fee-chain-name">{{ chainLabel }}</span>
              </span>
            </p>
            <p v-if="unlistedChain" class="fee-hint">
              {{ $t("home.unlistedChainHint") }}
            </p>

            <!-- 基础字段 -->
            <div class="group">
              <span class="spec">Token</span>
              <el-form size="medium" label-position="top" :model="formLabelAlign">
                <div class="field-grid">
                  <el-form-item :label="$t('home.quancheng')">
                    <el-input
                      v-model="formLabelAlign.name"
                      :placeholder="$t('home.quancheng1')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('home.jiancheng')">
                    <el-input
                      v-model="formLabelAlign.syname"
                      :placeholder="$t('home.jiancheng1')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('home.jingdu')">
                    <el-input v-model="formLabelAlign.jing" placeholder="18"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('home.zongliang')">
                    <el-input v-model="formLabelAlign.sum" placeholder="10000"></el-input>
                  </el-form-item>
                  <el-form-item class="span-2" :label="$t('home.guanli')">
                    <el-input
                      v-model="formLabelAlign.admin"
                      :placeholder="$t('home.admdizhi')"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <!-- 税：纯手续费代币才有 -->
            <div v-if="value === 2" class="group">
              <span class="spec">Tax</span>
              <el-form label-position="top" :model="form">
                <div class="field-grid">
                  <el-form-item class="span-half" :label="$t('home.yingxiao')">
                    <el-input v-model="form.mark">
                      <i slot="suffix">%</i>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="span-half" :label="$t('home.ranshao')">
                    <el-input v-model="form.combustion">
                      <i slot="suffix">%</i>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="span-2" :label="$t('home.yingxiaodizhi')">
                    <el-input
                      v-model="form.markw"
                      :placeholder="$t('home.yingxiaodizhiPh')"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <!-- 开源参数：折叠起来，不占视线 -->
            <el-collapse accordion>
              <el-collapse-item>
                <template slot="title">{{ $t("home.kaiyuan") }}</template>
                <div class="code-meta">
                  <span>Solidity {{ solidityVersion }}</span>
                  <span>License MIT</span>
                </div>
                <div class="code-actions">
                  <el-button @click="copyText">{{ $t("home.yuandaima") }}</el-button>
                  <el-button @click="copyConstructorParams">{{
                    $t("home.canshu")
                  }}</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>

            <!--
              部署要等钱包确认、等上链，这段时间按钮必须锁住：重复点会连开好几次
              钱包弹窗、发好几笔交易。loading 由 Element 顺带置 disabled，
              blocked() 负责别的动作在跑时把按钮压灰。
            -->
            <el-button
              class="btn-block"
              type="primary"
              :loading="creating"
              :disabled="blocked('create')"
              @click="concent"
              >{{ creating ? $t("home.creating") : $t("home.chuangjian") }}</el-button
            >

            <!-- 部署出来的合约地址 -->
            <div v-if="heyue" class="result">
              <span class="spec is-faint">Contract</span>
              <code @click="heyuecopy">{{ heyue }}</code>
              <i class="el-icon-document-copy" @click="heyuecopy"></i>
            </div>
          </div>
        </section>

      </div>

      <!-- 代币工具：作用在下面填写的合约地址上 -->
      <section class="card tools-card">
        <header class="card-head">
          <!-- 原来的 02（这条通道能做什么）挪进底部折叠面板了，编号顺延 -->
          <span class="spec-code spec">02</span>
          <h2>{{ $t("home.toolsTitle") }}</h2>
          <span class="spec is-faint card-head-meta">Tools</span>
        </header>
        <div class="card-body">
          <p class="tool-lead tools-intro">{{ $t("home.toolsLead") }}</p>

          <div class="tool">
            <h3>
              <span class="spec">A</span>{{ $t("home.tokenAddr") }}
            </h3>
            <p class="tool-lead">{{ $t("home.toolAddrHint") }}</p>
            <el-input
              v-model="tokenAddress"
              :placeholder="$t('home.daibidizhi')"
            ></el-input>
          </div>

          <div class="tool-grid">
            <div class="tool">
              <h3>
                <span class="spec">B</span>{{ $t("home.fangqi") }}
              </h3>
              <p class="tool-lead">{{ $t("home.toolFangqiHint") }}</p>
              <el-button
                class="btn-tool"
                type="primary"
                :loading="busyAction === 'ownership'"
                :disabled="blocked('ownership')"
                @click="transferOwnership"
                >{{ $t("home.queding") }}</el-button
              >
            </div>

          </div>
        </div>
      </section>

      <!--
        使用步骤与常见问题：SEO / AEO / GEO 要的文字都在这里，但默认折叠。
        内容留在 DOM 里（折叠面板只是 v-show，没有对机器隐藏），所以结构化数据
        与页面文字仍然对得上；用户则不用先看一屏说明，想问什么再点开。
        文案与 public/index.html 的预渲染块、JSON-LD 同源：src/seo/content.mjs
      -->
      <section class="seo-article">
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <span class="spec">Guide · FAQ</span>
              <span class="seo-panel-title">{{ seo.panelTitle }}</span>
            </template>

            <!-- 与 public/index.html 的静态副本共用 .seo-panel-body，两边内边距一致 -->
            <div class="seo-panel-body">
              <p class="seo-lead">{{ seo.answer }}</p>

              <!--
                这条通道的边界：原来占着右半边一整张卡，用户反馈「没什么用还占地方」，
                收进这个默认折叠的面板里 —— 想确认「能不能做靓号地址」的人自己点开看。
              -->
              <h2>{{ $t("home.anyChainCan") }}</h2>
              <ul class="info-list">
                <li class="yes">{{ $t("home.anyChainCan1") }}</li>
                <li class="yes">{{ $t("home.anyChainCan2") }}</li>
                <li class="no">{{ $t("home.anyChainCant1") }}</li>
                <li class="no">{{ $t("home.anyChainCant2") }}</li>
              </ul>
              <p class="note">{{ $t("home.anyChainFeeNote") }}</p>
              <p class="note is-brand">{{ $t("home.anyChainTip") }}</p>

              <h2>{{ seo.stepsTitle }}</h2>
              <ol class="seo-steps">
                <li v-for="step in seo.steps" :key="step">{{ step }}</li>
              </ol>

              <h2>{{ seo.feeTableTitle }}</h2>
              <div class="seo-facts">
                <table>
                  <tbody>
                    <tr v-for="chain in chainFees" :key="chain.id">
                      <th scope="row">{{ chain.name }}</th>
                      <td>{{ chain.price }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>{{ seo.feeTableNote }}</p>

              <h2>{{ seo.faqTitle }}</h2>
              <div v-for="item in seo.faq" :key="item.q" class="seo-faq">
                <h3>{{ item.q }}</h3>
                <p>{{ item.a }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </section>
    </main>

    <footer class="site-footer">
      <div class="site-footer-inner">
        <div class="footer-brand">
          <span class="brand-word">GTokenTool</span>
          <p>{{ $t("home.footerBlurb") }}</p>
        </div>

        <nav class="footer-column" :aria-label="$t('home.contactTitle')">
          <span class="spec is-faint">{{ $t("home.contactTitle") }}</span>
          <ul class="footer-link-list">
            <li v-for="item in contactLinks" :key="item.href">
              <a :href="item.href" target="_blank" rel="noopener noreferrer">
                {{ item.label }}<span aria-hidden="true"> ↗</span>
              </a>
            </li>
          </ul>
        </nav>

        <nav class="footer-column footer-sites" :aria-label="seo.relatedTitle">
          <span class="spec is-faint">{{ seo.relatedTitle }}</span>
          <ul class="footer-link-list">
            <li v-for="site in relatedSites" :key="site.href">
              <a :href="site.href" target="_blank" rel="noopener noreferrer">
                {{ site.label }}<span aria-hidden="true"> ↗</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="site-footer-meta">
        <span>{{ $t("home.footerDisclaimer") }}</span>
        <span>© {{ footerYear }} GTokenTool</span>
      </div>
    </footer>

    <!-- 常驻的赞助入口 + 收款弹窗 -->
    <button
      class="support-fab"
      type="button"
      :title="$t('home.kafei')"
      :aria-label="$t('home.kafei')"
      @click="dialogVisible = true"
    >
      <img src="../img/zanzhu.png" alt="" />
    </button>
    <el-dialog
      :title="$t('home.supportTitle')"
      :visible.sync="dialogVisible"
      width="min(420px, 86%)"
    >
      <div class="dialog-body">
        <p>{{ $t("home.kafei") }}<i class="el-icon-coffee-cup"></i></p>
        <img class="qr" src="../img/erweima.jpg" :alt="$t('home.qrAlt')" />
        <div class="addr">
          <span>0x7d1b5a54b17a4D2bC2CEA69ae29d1A441020bbE1</span>
          <i
            class="el-icon-document-copy"
            role="button"
            tabindex="0"
            :aria-label="$t('home.copyAddr')"
            @click="copyContractAddress"
          ></i>
        </div>
        <p>
          <a :href="supportLink.href" target="_blank" rel="noopener noreferrer">{{
            supportLink.label
          }}</a>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ethers, BigNumber } from "ethers";
import { STANDARDTOKEN, FEETOKEN, OwnableABI } from "../config";
import { encodeParams } from "../utils";
import { abi, bytecode, abi2, bytecode2 } from "./config/abi";
import { price } from "./config/price";
// SEO / AEO 文案与站点头信息：静态文件（index.html、llms.txt）也读同一份
import { CHAINS, CHAIN_FEES, UNLISTED_CHAIN_FEE, contentFor, SITE } from "../seo/content.mjs";
import { applyHead, syncLangParam } from "../seo/head";

/* 平台收款地址：构造函数里转给这个地址，部署成功即已付费 */
const FEE_ADDRESS = SITE.feeAddress;

/* 价目表里没有的链，代码里按 1 个原生币收费（与 concent 的兜底值一致） */
const FALLBACK_FEE_WEI = "1000000000000000000";

/* EIP-1193 的 chainId 是十六进制字符串，有的钱包给十进制，两种都收；
   其余形状（null / 空串 / 超出安全整数 / NaN）一律当「读不到」——
   宁可显示「认不出这条链」，也不把一个假 ID 摆到页面上。 */
function parseChainId(raw) {
  if (raw === null || raw === undefined) return null;
  const id = typeof raw === "number" ? raw : Number(String(raw).trim());
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export default {
  data() {
    return {
      dialogVisible: false,
      /* 连上以后换成缩略地址（见 lian）；没连时按钮显示的是「连接钱包」 */
      ownadress: "",
      account: "",
      formLabelAlign: {
        name: "",
        syname: "",
        jing: "18",
        sum: "10000",
        admin: "",
      },
      options: [
        {
          value: 1,
          label: "biaozhun",
        },
        {
          value: 2,
          label: "shouxufei",
        },
      ],
      value: 1,
      form: {
        mark: 0,
        combustion: 0,
        markw: "",
      },
      /* 当前链的 chainId（字符串）。费用和链名都由它推出来，不再单独存一份读数 */
      chainId: "",
      /* 钱包事件只绑定一次；window.ethereum 有可能是挂载之后才注入的 */
      chainEventsBound: false,
      /* 兜底轮询的定时器 id（见 watchChain） */
      chainTimer: null,
      /*
        正在进行的链上操作（'' 表示空闲）。取值：
          create / ownership
        同一时刻只允许一个 —— 两笔交易同时弹钱包，用户根本分不清哪笔是哪笔。
      */
      busyAction: "",
      heyue: "",
      tokenAddress: "",
    };
  },
  computed: {
    /* 创建代币进行中：按钮转圈 + 换成「部署中…」 */
    creating() {
      return this.busyAction === "create";
    },
    /* 当前语言的 SEO / AEO 文案（zh / en 两份都在 src/seo/content.mjs） */
    seo() {
      return contentFor(this.$i18n.locale);
    },
    /* 常见链的部署费表，费用数字与 price.js 核对过（见 scripts/generate-seo.mjs） */
    chainFees() {
      return CHAIN_FEES.map((chain) => ({
        ...chain,
        price: `${chain.fee} ${chain.unit}`,
      }));
    },
    /* 费用读数：数字 + 这条链的原生币单位。没连钱包/读不到链时给「—」，
       不再像以前那样先摆一个 1 出来 —— 那会被人当成价格。 */
    feeLabel() {
      if (!this.chainId) return "—";
      const hit = price.find((item) => Number(item.name) === Number(this.chainId));
      /* 价目表里没有这条链：按兜底值收费，但单位叫不出名字，就写「原生币」 */
      if (!hit) return `${UNLISTED_CHAIN_FEE} ${this.$t("home.nativeCoin")}`;
      const named = CHAINS.find((chain) => chain.id === Number(this.chainId));
      /* formatEther 会把 50 份写成「50.0」，尾数那个 .0 是多余的 */
      const amount = ethers.utils.formatEther(hit.unit).replace(/\.0+$/, "");
      return `${amount} ${named ? named.unit : this.$t("home.nativeCoin")}`;
    },
    /* 当前链不在价目表里：费用会走 1 个原生币的兜底，这种时候页面上要说明白，
       否则用户只看到一串对不上钱包的 chainId，不知道发生了什么 */
    unlistedChain() {
      return Boolean(this.connected && this.chainId && !this.isKnownChain(this.chainId));
    },
    /* 当前链：认得的写名字，认不得的只给 chainId（名字是辅助，ID 才是准的） */
    chainLabel() {
      if (!this.chainId) {
        /* 连上了却读不出链：如实说读不出来，别写成「未连接」误导人 */
        return this.connected ? this.$t("home.chainUnknown") : this.$t("home.notConnected");
      }
      const named = CHAINS.find((chain) => chain.id === Number(this.chainId));
      return named
        ? `${named.name} · #${this.chainId}`
        : `${this.$t("home.chainIdLabel")} ${this.chainId}`;
    },
    relatedSites() {
      return [{ label: SITE.brand, href: SITE.mainSite }, ...SITE.siblings];
    },
    contactLinks() {
      const locale = this.$i18n.locale === "en" ? "en" : "zh";
      return [
        ...SITE.social.map((item) => ({
          label: item.label[locale],
          href: item.href,
        })),
        {
          label: SITE.guides.label[locale],
          href: SITE.guides.href[locale],
        },
      ];
    },
    supportLink() {
      return this.contactLinks[this.$i18n.locale === "en" ? 1 : 0];
    },
    footerYear() {
      return new Date().getFullYear();
    },
    /* 钱包按钮：连上前后是两种形态（主色实心 CTA / 白底等宽地址） */
    connected() {
      return Boolean(this.account);
    },
    currentMode() {
      return this.options.find((item) => item.value === this.value) || this.options[0];
    },
    langLabel() {
      return this.$i18n.locale === "en" ? "English" : "简体中文";
    },
    solidityVersion() {
      return "0.8.6";
    },
  },
  mounted() {
    /* `/en/` 有独立的英文静态页；这里负责挂载后复核 head，并把旧 ?lang=en 规范化 */
    applyHead(this.$i18n.locale);
    syncLangParam(this.$i18n.locale);
    this.watchChain();
  },
  beforeDestroy() {
    /* 组件销毁时把补问的监听摘掉，别留在 window 上 */
    window.clearInterval(this.chainTimer);
    window.removeEventListener("focus", this.onChainMayHaveChanged);
    document.removeEventListener("visibilitychange", this.onChainMayHaveChanged);
  },
  methods: {
    /*
      别的动作正在进行时，这个按钮要不要禁用。
      自己那个动作靠 el-button 的 :loading 兜住（loading 会同时置 disabled）。
    */
    blocked(action) {
      return Boolean(this.busyAction) && this.busyAction !== action;
    },
    /*
      把 ethers / 钱包抛出来的错误翻成一句能看懂的话。

      合约自己 require 失败时，原因字符串就藏在 error.data.message（或 error.reason）
      里。以前这里一律吞掉、只显示「失败」，用户根本不知道差在哪一步。
    */
    reasonOf(error) {
      if (!error) return this.$t("home.errUnknown");
      const data = error.data || {};
      const reason =
        data.message ||
        error.reason ||
        (error.error && error.error.message) ||
        error.message ||
        "";
      return String(reason).trim() || this.$t("home.errUnknown");
    },
    /*
      地址规范化。从浏览器 / 区块浏览器复制出来的地址大小写经常不对，
      ethers 对校验和不合法的大小写会直接抛 "bad address checksum"，
      用户看到的就是「失败」，完全不知道是地址大小写的事。
      先按原样试，不行就按全小写再试一次 —— 地址本身没变，只是把大小写规范化。
      返回空串表示这串东西根本不是地址。
    */
    toAddress(value) {
      const text = String(value || "").trim();
      try {
        return ethers.utils.getAddress(text);
      } catch {}
      try {
        return ethers.utils.getAddress(text.toLowerCase());
      } catch {}
      return "";
    },
    /*
      四个工具按钮共用的前置检查：钱包连了没、代币地址填对没。
      通过就返回规范化后的地址（后面直接用它构造合约），不通过返回空串并给出提示。
    */
    toolTargetAddress() {
      if (!this.account) {
        this.$message({ message: this.$t("home.needWallet"), type: "error" });
        return "";
      }
      const target = this.toAddress(this.tokenAddress);
      if (!target) {
        this.$message({
          message: this.tokenAddress
            ? this.$t("home.badTokenAddr")
            : this.$t("home.enterTokenAddr"),
          type: "error",
        });
        return "";
      }
      return target;
    },
    /*
      提交前的字段类型校验。

      合约的构造参数都是有类型的（uint8 / uint256 / address），类型不对时 ethers 会抛
      「invalid BigNumber string (value="0.1")」这种用户完全看不懂的错。

      这里按类型先挡一道，报错直接点名是哪个字段、该填什么，钱包弹窗都不会弹出来。
      返回第一条错误，空串表示通过。
    */
    validateFields() {
      const form = this.formLabelAlign;
      const datas = this.form;
      const text = (value) =>
        String(value === null || value === undefined ? "" : value).trim();
      /* 只认非负整数：0.1、-1、1e5、"12个" 都不行 */
      const intIn = (value, min, max) => {
        const raw = text(value);
        if (!/^\d+$/.test(raw)) return null;
        const num = Number(raw);
        return num >= min && num <= max ? num : null;
      };
      /* 走 toAddress：大小写不规范但能还原的地址也算合法，别把人卡在门口 */
      const isAddress = (value) => Boolean(this.toAddress(value));

      if (!text(form.name)) return this.$t("home.vName");
      if (!text(form.syname)) return this.$t("home.vSymbol");
      if (intIn(form.jing, 0, 255) === null) return this.$t("home.vDecimals");
      const supply = intIn(form.sum, 1, Number.MAX_SAFE_INTEGER);
      if (supply === null) return this.$t("home.vSupply");
      if (!isAddress(form.admin)) return this.$t("home.vAdmin");

      if (this.value === 2) {
        if (intIn(datas.mark, 0, 100) === null) return this.$t("home.vMarkFee");
        if (intIn(datas.combustion, 0, 100) === null)
          return this.$t("home.vBurnFee");
        if (!isAddress(datas.markw)) return this.$t("home.vMarkWallet");
      }
      return "";
    },
    /*
      问钱包「现在连的是哪条链」。三个来源会打架，取值规则：
        1. eth_chainId        —— EIP-1193 标准方法，最可信
        2. ethereum.chainId   —— 老属性，通常也是十六进制
        3. ethereum.networkVersion —— 注意这是「网络 ID」，不是 chainId。
           MetaMask 给自定义 RPC 的网络会编一个跟 chainId 毫无关系的大数字
           （实测过 3448148188 这种），所以它只有在刚好能对上我们自己的链表时
           才被采信，否则直接丢掉。
      多个来源不一致时，优先信「能对上链表」的那个：用户把 Polygon 加成自定义
      RPC 时，标准来源给 137、networkVersion 给那串大数字，按这条规则取 137。

      每个来源单独 try：有的钱包读取某个属性会直接抛，不能让它把别的来源带走。
    */
    async readChainId() {
      const eth = window.ethereum;
      if (!eth) return null;

      let rpc = null;
      try {
        if (eth.request) {
          rpc = parseChainId(await eth.request({ method: "eth_chainId" }));
        }
      } catch {}

      let injected = null;
      try {
        injected = parseChainId(eth.chainId);
      } catch {}

      let networkVersion = null;
      try {
        networkVersion = parseChainId(eth.networkVersion);
      } catch {}

      /*
        三个来源都留作候选，但选法不是「谁先读到用谁」：先找能对上链表的那一个。
        networkVersion 单独放在最后，它只在前面全读不到时才被采用 —— 采用它的时候
        基本就是钱包配置有问题（自定义 RPC 的网络 ID 对不上 chainId），
        页面会把这串数字原样显示出来并给出解释，而不是假装读到了链。
      */
      const candidates = [rpc, injected, networkVersion].filter((id) => id !== null);
      if (!candidates.length) return null;

      const known = candidates.find((id) => this.isKnownChain(id));
      const picked = known === undefined ? candidates[0] : known;

      if (!this.isKnownChain(picked)) {
        /* 认不出的链：三个来源原样打出来，方便判断是钱包的锅还是链表要补 */
        console.warn("[chain] 认不出的网络", {
          eth_chainId: rpc,
          chainId: injected,
          networkVersion,
          picked,
        });
      }
      return picked;
    },
    /* 这条链在不在我们自己的表里（价目表 + 名字表） */
    isKnownChain(id) {
      const target = Number(id);
      return (
        price.some((item) => Number(item.name) === target) ||
        CHAINS.some((chain) => chain.id === target)
      );
    },
    async syncChain() {
      const id = await this.readChainId();
      if (!id) return;
      const next = String(id);
      /* 值没变就不要动响应式数据，省得每两秒白跑一次渲染 */
      if (next !== this.chainId) this.chainId = next;
    },
    bindChainEvents() {
      const eth = window.ethereum;
      if (!eth || !eth.on || this.chainEventsBound) return;
      this.chainEventsBound = true;
      eth.on("chainChanged", () => this.syncChain());
      eth.on("networkChanged", () => this.syncChain());
      eth.on("accountsChanged", () => this.syncChain());
    },
    /* 回到这个标签页时补问一次：漏掉事件、或钱包当时还没注入，都能在这一步找回来 */
    onChainMayHaveChanged() {
      if (document.hidden) return;
      this.bindChainEvents();
      this.syncChain();
    },
    watchChain() {
      this.bindChainEvents();
      this.syncChain();
      window.addEventListener("focus", this.onChainMayHaveChanged);
      document.addEventListener("visibilitychange", this.onChainMayHaveChanged);
      /*
        兜底轮询：有的钱包既不给 window.ethereum.chainId，也不发 chainChanged，
        只靠事件的话这一行永远不会跟着钱包走（用户反馈的就是这个）。
        2 秒问一次、标签页不可见时跳过；provider 是本地注入的，代价可以忽略。
      */
      this.chainTimer = window.setInterval(() => {
        if (!document.hidden) this.syncChain();
      }, 2000);
    },

    /* 这条链实际要付的部署费（wei）。价目表里没有就按兜底值 —— 收费与显示共用它，
       免得页面上标一个数、交易里付另一个数。 */
    feeWeiForChain(chainId) {
      const hit = price.find((item) => Number(item.name) === Number(chainId));
      return hit ? hit.unit : FALLBACK_FEE_WEI;
    },
    // 赞助弹窗里的收款地址复制
    copyContractAddress() {
      this.copyPlainText(FEE_ADDRESS);
    },
    /* 复制一段文本：老的 execCommand 兜底方案，网页里到处在用 */
    copyPlainText(text) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message({
        message: this.$t("home.copyOk"),
        type: "success",
      });
    },
    async copyText() {
      // 取对应模式的源码文本
      const response = await fetch(`/${this.value}.text`);
      const text = await response.text();
      this.copyPlainText(text);
    },
    copyConstructorParams() {
      /* 参数要按类型编码，填错了同样会抛 ethers 的原始错误，这里先给一句人话 */
      const invalid = this.validateFields();
      if (invalid) {
        this.$message({ message: invalid, type: "warning" });
        return;
      }
      /* 同上：构造参数里的地址要先规范化 */
      this.formLabelAlign.admin =
        this.toAddress(this.formLabelAlign.admin) || this.formLabelAlign.admin;
      if (this.form.markw) {
        this.form.markw = this.toAddress(this.form.markw) || this.form.markw;
      }
      // 根据所选模板值获取相应的构造函数和构造参数
      let constructorTypes, constructorArgs;
      const selectedTemplate = this.value;
      if (selectedTemplate === 1) {
        constructorTypes = STANDARDTOKEN.constructorTypes;
        constructorArgs = [
          this.formLabelAlign.name,
          this.formLabelAlign.syname,
          this.formLabelAlign.jing,
          this.formLabelAlign.sum,
          this.formLabelAlign.admin,
          FEE_ADDRESS,
        ];
      } else if (selectedTemplate === 2) {
        constructorTypes = FEETOKEN.constructorTypes;
        constructorArgs = [
          this.formLabelAlign.name,
          this.formLabelAlign.syname,
          this.formLabelAlign.jing,
          this.formLabelAlign.sum,
          this.formLabelAlign.admin,
          this.form.mark,
          this.form.combustion,
          this.form.markw,
          FEE_ADDRESS,
        ];
      } else {
        return;
      }

      // 把构造参数编码成字符串再复制到剪贴板
      this.copyPlainText(encodeParams(constructorTypes, constructorArgs));
    },
    translate(lang) {
      this.$i18n.locale = lang;
      /* 内容、<head>、地址三件事一起换：英文页面配中文标题、或地址还停在中文，
         对搜索和分享都是坏信号 */
      applyHead(lang);
      syncLangParam(lang);
    },
    async concent() {
      /* 双保险：按钮已经 loading（Element 会顺带置 disabled），这里再拦一道，
         键盘回车、脚本触发之类的路径也进不来第二笔 */
      if (this.busyAction) return;

      /* 先按合约参数类型把字段校验一遍：类型不对的话，钱包根本不该弹出来 */
      const invalid = this.validateFields();
      if (invalid) {
        this.$message({
          message: invalid,
          type: "warning",
        });
        return;
      }
      /* 地址统一成合法的校验和格式再往下走（大小写不规范时 ethers 会直接抛错），
         写回表单，用户也能看到被规范化的地址 */
      this.formLabelAlign.admin =
        this.toAddress(this.formLabelAlign.admin) || this.formLabelAlign.admin;
      if (this.form.markw) {
        this.form.markw = this.toAddress(this.form.markw) || this.form.markw;
      }
      const provider = new ethers.providers.Web3Provider(window["ethereum"]);
      const signer = provider.getSigner();
      let Targetabi = "";
      let Targetbytecode = "";
      let data = {};
      switch (this.value) {
        case 1:
          Targetabi = abi;
          Targetbytecode = bytecode;
          data = [
            this.formLabelAlign.name,
            this.formLabelAlign.syname,
            this.formLabelAlign.jing,
            this.formLabelAlign.sum,
            this.formLabelAlign.admin,
            FEE_ADDRESS,
          ];
          break;
        case 2:
          Targetabi = abi2;
          Targetbytecode = bytecode2;
          data = [
            this.formLabelAlign.name,
            this.formLabelAlign.syname,
            this.formLabelAlign.jing,
            this.formLabelAlign.sum,
            this.formLabelAlign.admin,
            this.form.mark,
            this.form.combustion,
            this.form.markw,
            FEE_ADDRESS,
          ];

          break;
        default:
          break;
      }
      const contractFactory = new ethers.ContractFactory(
        Targetabi,
        Targetbytecode,
        signer
      );
      /* 费用按点下去这一刻的链取值 —— 现问钱包一次，不用 networkVersion 那个
         切链后可能还没更新的 legacy 属性；读不到链就按兜底价，与显示逻辑一致 */
      const chainNow = await this.readChainId();
      if (chainNow) this.chainId = String(chainNow);
      const value = this.feeWeiForChain(chainNow);

      /* 校验都过了，从现在开始按钮进入「部署中」并锁住，直到成功或失败 */
      this.busyAction = "create";
      try {
        const balance = await provider.getBalance(this.account);

        if (BigNumber.from(balance).lt(BigNumber.from(value))) {
          return this.$message({
            message: this.$t("home.lowBalance"),
            type: "error",
          });
        }
        const contract = await contractFactory.deploy(...data, { value: value });

        this.$message({
          message: this.$t("home.contractAddr", { addr: contract.address }),
          type: "success",
        });
        this.heyue = contract.address;

        await contract.deployed();
        this.$message({
          message: this.$t("home.contractLive"),
          type: "success",
        });
      } catch (error) {
        console.log(error, "error");
        /* error.data 在钱包直接拒绝（用户点了取消）时是 undefined，
           以前这里会再抛一个 TypeError，结果什么提示都没有 */
        const message =
          (error && error.data && error.data.message) || (error && error.message) || "";
        if (message.includes("insufficient funds for gas * price + value")) {
          this.$message({
            message: this.$t("home.lowBalance"),
            type: "error",
          });
        } else if (message.includes("User denied") || message.includes("rejected")) {
          this.$message({
            message: this.$t("home.txCancelled"),
            type: "warning",
          });
        } else {
          this.$message({
            message: this.$t("home.deployFail", {
              msg: message || this.$t("home.errUnknown"),
            }),
            type: "error",
          });
        }
      } finally {
        this.busyAction = "";
      }
    },
    async lian() {
      if (window.ethereum) {
        const web3Provider = window.ethereum;
        try {
          const addressArray = await web3Provider.request({
            method: "eth_requestAccounts",
          });
          this.account = addressArray[0];
          this.ownadress =
            addressArray[0].slice(0, 4) + "..." + addressArray[0].slice(-4);
          this.formLabelAlign.admin = addressArray[0];
          const provider = new ethers.providers.Web3Provider(window["ethereum"]);
          const Network = await provider.getNetwork();
          this.chainId = String(Network.chainId);
        } catch {}
      }
    },
    // 复制合约地址
    heyuecopy() {
      if (!this.heyue) return;
      this.copyPlainText(this.heyue);
    },
    async transferOwnership() {
      if (this.busyAction) return;
      try {
        const target = this.toolTargetAddress();
        if (!target) return;
        this.busyAction = "ownership";
        const provider = new ethers.providers.Web3Provider(window["ethereum"]);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(target, OwnableABI, signer);
        await contract.transferOwnership(
          "0x000000000000000000000000000000000000dEaD"
        );
        this.$message({
          message: this.$t("home.renounceOk"),
          type: "success",
        });
      } catch (error) {
        this.$message({
          message: this.$t("home.renounceFail", { msg: this.reasonOf(error) }),
          type: "error",
        });
      } finally {
        this.busyAction = "";
      }
    },

  },
};
</script>
